exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/AppDev/meetup/kla-firebase-poker/web/src/app/component/ticket-create/ticket-create.component.css
// module id = ../../../../../src/app/component/ticket-create/ticket-create.component.css
// module chunks = main